import * as React from 'react'
import { useState } from 'react'
import { useTransition } from 'react-spring'

import UploaderError from './UploaderError'

const UploaderErrors = ({
  errors,
  constraints,
  onErrorClose,
}: {
  errors: Upload.DirectorConstraintError[]
  constraints: Upload.DirectorConstraints
  onErrorClose: (error: Upload.DirectorConstraintError) => void
}) => {
  const config = { tension: 125, friction: 20, precision: 0.1 }
  const [refMap] = useState(() => new WeakMap())
  const [cancelMap] = useState(() => new WeakMap())

  const transition = useTransition(errors, {
    key: (item: Upload.DirectorConstraintError) => item.id,
    from: { opacity: 0, height: 0, life: '100%' },
    enter: (item) => async (next, stop) => {
      cancelMap.set(item, () => {
        stop()
        onErrorClose(item)
      })
      await next({
        opacity: 1,
        height: refMap.get(item).offsetHeight,
        config,
      })
      await next({ life: '0%', config: { duration: 5000 } })
      cancelMap.get(item)()
    },
    leave: (item) => async (next) => {
      await next({ opacity: 0, config })
      await next({ height: 0, config })
    },
  })

  return (
    <div className="uploader__errors">
      {transition(({ life, ...style }: any, error: Upload.DirectorConstraintError) => (
        <UploaderError style={style} error={error} constraints={constraints} cancelMap={cancelMap} refMap={refMap} />
      ))}
    </div>
  )
}

export default UploaderErrors
